
  import { Vue, Component } from "vue-property-decorator";
  import { getModule } from "vuex-module-decorators";
  import { Auth } from "@/store/modules/AuthModule";
  import store from "@/store";
  import "@/helper/validate";
  import { UserService } from "@/services";
  const AuthModule = getModule(Auth, store);

  @Component({
    name: "PageUnauthorize"
  })
  export default class PageUnauthorize extends Vue {
    publicPath: string = process.env.BASE_URL as string;
    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }

    // NOTE: only working on production
    // check if user login from current site
    // if not check the cookies, if exist user already login from main site
    // re-authentication
    async reAuthentication() {
      await this.authorize();
    }
    async authorize() {
      this.$mainLoader.show();
      var response = await UserService.GetAuthorizeUrl();
      this.$mainLoader.hide();
      if (response.status === 200) {
        this.showAuthorizePopup(response.data);
      }
    }
    showAuthorizePopup(url: string) {
      const isAuthorizePage =
        window.location.href.indexOf("expired") >= 0 ? true : false;
      localStorage.setItem(
        "last_url",
        isAuthorizePage ? process.env.BASE_URL : window.location.href
      );

      window.location.assign(url);
    }
  }
